import React from "react";

/**
 * TileGrid — auto-flowing bento grid that rebalances when modules disappear.
 *
 * Per design_guidelines.md §3.3 (Invisible means non-existent):
 *   - hidden tiles return null and the grid reflows automatically
 *   - never renders empty placeholders or "upgrade" cards
 *   - generous spacing per §2.4 — `gap-6 lg:gap-8`
 *
 * Per Binding Rule #7: maximum 6 tiles per home view. The caller is
 * responsible for honoring this — the grid does not enforce a count, it
 * just lays out whatever children are passed.
 *
 * Responsive grid:
 *   mobile  → 1 column  (touch-friendly, stacked)
 *   tablet  → 2 columns
 *   desktop → 3 columns (max — prevents desktop noise per design)
 */
export const TileGrid = ({ children, "data-testid": testId = "ob-tile-grid" }) => {
    return (
        <div
            data-testid={testId}
            className="grid gap-6 lg:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-fr"
        >
            {children}
        </div>
    );
};
